import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './FullScreenImageOverlay.module.css';

const FullScreenImageOverlay = () => {
  const { imageId } = useParams(); 
  const location = useLocation();
  const navigate = useNavigate();

  const imageURL = location.state?.imageURL;

  if (!imageURL) {
    console.error("Image URL is missing in state.");
    return null; // Prevent rendering if imageURL is missing
  }

  // Animation variants
  const backdropVariants = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 },
  };

  const modalVariants = {
    hidden: { y: '-100vh', opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { delay: 0.2 } },
  };

  return (
    <AnimatePresence>
      <motion.div
        className={styles.backdrop}
        variants={backdropVariants}
        initial="hidden"
        animate="visible"
        exit="hidden"
        onClick={() => navigate(-1)} 
      >
        <motion.div
          className={styles.modal}
          variants={modalVariants}
          initial="hidden"
          animate="visible"
          exit="hidden"
          onClick={(e) => e.stopPropagation()} 
        >
          <img
            src={imageURL}
            alt={`Expanded view of ${imageId}`}
            className={styles.fullImage}
          />
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default FullScreenImageOverlay;
